export default function () {
    return {
        selectedPreOrderUnit: {},
    };
}
